import { Button, Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import CheckValue from '../Filter/CheckValue/CheckValue';
import '../Filter/style.css';
// import { InputPrice } from '../../InputPrice';
import Price from '../Filter/Price/Price';

const Filter = ({
    xs = 24,
    sm = 24,
    md = 24,
    lg = 6,
    xl = 6,
    style = {},
    data,
    category = null,
}) => {
    const [value, setValue] = useState({});
    const [search] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (data) {
            const result = {};
            data?.forEach((item) => {
                if (
                    item.key === 'natural_price' ||
                    item.key === 'juridical_price'
                ) {
                    result[item.key] = search.get(item.key) ?? '';
                } else {
                    result[item.key] =
                        // eslint-disable-next-line
                        search.getAll(`${item.key}[]`).length !== 0
                            ? search.getAll(`${item.key}[]`)
                            : search.get(item.key)
                              ? [search.get(item.key)]
                              : [];
                }
            });
            setValue(result);
        }
    }, [data]);
    const resetHandler = () => {
        const result = {};
        data.forEach((item) => {
            if (
                item.key === 'natural_price' ||
                item.key === 'juridical_price'
            ) {
                result[item.key] = search.get(item.key) ?? '';
            } else {
                result[item.key] =
                    search.getAll(`${item.key}[]`) ??
                    (search.get(item.key) ? [search.get(item.key)] : []);
            }
        });
        setValue(result);
    };
    const confirmHandler = (outKey = null) => {
        let searchStr = '';
        // eslint-disable-next-line
        for (let key in value) {
            if (!outKey || key !== outKey) {
                if (value[key]?.length > 0) {
                    if (key === 'natural_price' || key === 'juridical_price') {
                        if (value[key] !== '|') {
                            searchStr += `&${key}=${value[key]}`;
                        }
                    } else if (value[key].length === 1) {
                        searchStr += `&${key}=${[value[key]]}`;
                    } else {
                        let str = '';
                        value[key].forEach((item) => {
                            str += `&${key}[]=${item}`;
                        });
                        searchStr += str;
                    }
                }
            }
        }
        if (category) {
            navigate(`/categories/${category}?${searchStr}`);
        } else {
            navigate(`/search?search=${search.get('search')}${searchStr}`);
        }
    };

    return (
        <Col
            className="filter-container"
            style={style}
            xs={xs}
            sm={sm}
            md={md}
            lg={lg}
            xl={xl}
        >
            <Row style={{ flexDirection: 'column', gap: '12px' }}>
                {data?.map((item) => {
                    if (item.key === 'category') {
                        return null;
                    } else if (
                        item.key === 'natural_price' ||
                        item.key === 'juridical_price'
                    ) {
                        return (
                            <Price
                                minValue={value[item.key]?.split('|')[0] ?? ''}
                                maxValue={value[item.key]?.split('|')[1] ?? ''}
                                title={item.name}
                                onChangeMax={(v) => {
                                    setValue((val) => {
                                        const old = (val[item.key] ?? '').split(
                                            '|'
                                        );
                                        old[1] = v;
                                        return {
                                            ...val,
                                            [item.key]: old.join('|'),
                                        };
                                    });
                                }}
                                onChangeMin={(v) => {
                                    setValue((val) => {
                                        const old = (val[item.key] ?? '').split(
                                            '|'
                                        );
                                        old[0] = v;
                                        return {
                                            ...val,
                                            [item.key]: old.join('|'),
                                        };
                                    });
                                }}
                                max={item.bucket.max}
                                min={item.bucket.min}
                                key={item.key}
                            />
                        );
                    } else {
                        return (
                            <CheckValue
                                value={value[item.key]}
                                changeValue={(v) =>
                                    setValue((val) => ({
                                        ...val,
                                        [item.key]: v,
                                    }))
                                }
                                confirm={(outKey) => confirmHandler(outKey)}
                                title={item.name}
                                key={item.key}
                                keyEl={item.key}
                                items={item.bucket}
                            />
                        );
                    }
                })}
            </Row>
            <Row
                justify="space-evenly"
                style={{ margin: '10px 0', gap: 20, maxWidth: '380px' }}
            >
                <Button
                    className="filter-btn-ok"
                    style={{ width: '40%', minWidth: 150 }}
                    type="primary"
                    onClick={() => confirmHandler()}
                >
                    Применить
                </Button>
                <Button
                    className="filter-btn-cancel"
                    style={{ width: '40%', minWidth: 150 }}
                    onClick={() => resetHandler()}
                >
                    Сбросить
                </Button>
            </Row>
        </Col>
    );
};

export default Filter;
